import { ConverterService, OccEndpointsService, OccProductAdapter, OccRequestsOptimizerService } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CustomOccProductAdapter extends OccProductAdapter {
  constructor(
    http: HttpClient,
    occEndpoints: OccEndpointsService,
    converter: ConverterService,
    requestsOptimizer: OccRequestsOptimizerService,
  ) {
    super(http, occEndpoints, converter, requestsOptimizer);
  }

  protected override getEndpoint(code: string, scope?: string): string {
    let url = this.occEndpoints.buildUrl('product', {
      urlParams: { productCode: code },
      scope,
    });

    if (scope === 'details') {
      url += `&cacheControl=${new Date().getTime()}`;
    }

    return url;
  }
}
